import React, { useState, useEffect } from 'react'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import Successstory from '../../components/Successstory'
import usePageSEO from '../../hooks/usePageSEO'
import axios from "axios";
import Loader from '../../components/Loader'
import Slider from 'react-slick';


const CaseStudy = () => {
  const [loading, setLoading] = useState(true);
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const siteUrl = process.env.REACT_APP_BACKEND_URL;
  const [caseStudyWidget, setCaseStudyWidget] = useState()
  const [metaTitle, setMetaTitle] = useState('')
  const [metaDescription, setMetaDescription] = useState('')
  const [caseStudy, setCaseStudy] = useState([])

  const apiUrl = apiBaseUrl+`aboutpage`;



  const fetchPagedata = async() => {
    try{
    return await axios.get(apiUrl).then((res) => {
      setMetaTitle(res.data.page.meta_title);
      setMetaDescription(res.data.page.meta_description);
      setCaseStudyWidget(res.data.casestudywidget)
      setCaseStudy(res.data.casestudy)
    });
    }catch(err){
      console.log(err);
    }
  };  

  useEffect(() => {
    setTimeout(() => {
      fetchPagedata()
        setLoading(false);
    }, 2000);
  }, []);

  usePageSEO({
    title: `${metaTitle}`,
    description: `${metaDescription}`
  })  

  const casestudysettings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
          },
        },
      ],         
  }; 

  return (
    <>
    <Header/>
    { loading && (<Loader />)}
    <div id="case-study" className="container vertical-gap"><hr/></div>
	
	<section className="section-content-block pb1-170">
    <div className="container">
      <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 text-center">                       
              <div className="about-us-intro">
                <p className="blue">{caseStudyWidget?.name}</p>
                <h2 className="heading">{caseStudyWidget?.heading}</h2>
                <p className='col-lg-offset-2 col-lg-8 col-sm-12 success-case-study-desc'>{caseStudyWidget?.description}</p>
              </div>                            
          </div> 
      </div>
				
      {(caseStudy.length > 0) && (
			<div className="row pb-100">
					<div className="casestudies-carousel col-sm-12 owl-carousel">
            <Slider {...casestudysettings}>
            {caseStudy.map((item, index)=>{
              return (
                <Successstory
                  key={index}
                  prm= {{
                    name: item?.name,
                    slug: item?.slug,
                    case_type: item?.case_type,
                    short_description: item?.short_description,
                    image: `${siteUrl}${item?.image}`
                  }}
                />
              )
            })}
            </Slider>
          </div>
      </div> 
      )}  
		</div>
  </section>
    
    <Footer/>
    </>
  )
}

export default CaseStudy